import './HeaderAdmin.scss'

import { MenuOutlined } from '@ant-design/icons'
import { LogoutOutlined } from '@ant-design/icons/lib/icons'
import { Button } from 'antd'
import classNames from 'classnames'
import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import AppContext from '../../../context/AppContext'
import { useHesapBilgilerimQuery, useSubelerQuery } from '../../../gql/GeneratedGraphqlTypes'
import { DEFAULT_API_TOKEN } from '../../../utils/const'
import { clearLoginSession } from '../../../utils/helpers'
import { AuthState } from '../../../utils/types'
import Spinner from '../../spinner/Spinner'
import Toolbar from '../toolbar/Toolbar'
import { ReactComponent as UserIcon } from './toolbar-icons/Vector.svg'

interface HeaderProps {
  userData: null
  drawerVisible: boolean
  setDrawerVisible: Dispatch<SetStateAction<boolean>>
  isSmallScreen: boolean
  renk1: string | null | undefined
  renk2: string | null | undefined
}

const HeaderAdmin: React.FC<HeaderProps> = (props) => {
  const { isSmallScreen, setDrawerVisible, renk1 } = props
  const { data, error, loading: queryLoading } = useHesapBilgilerimQuery()
  const { token, setToken, setAuthState, setGlobalNotification, setCiro, okul, setSiparisYetki } = useContext(AppContext)
  const navigate = useNavigate()
  const {
    data: subeQuery,
    loading: subeLoading,
    error: subeError,
  } = useSubelerQuery({
    skip: token === '' || token === DEFAULT_API_TOKEN,
  })
  const handleDrawerOpen = () => {
    setDrawerVisible(true) // Drawer'ı aç
  }
  const classes = classNames('db-admin-header-menu')
  useEffect(() => {
    if (setCiro) {
      setCiro(subeQuery?.profil?.ciro_yetkisi ? subeQuery.profil.ciro_yetkisi : false)
    }
    if (setSiparisYetki) {
      setSiparisYetki(subeQuery?.profil?.is_cirosip ? subeQuery.profil.is_cirosip : false)
    }
    const yetkiliOkullar = subeQuery?.profil?.okul_id || []; // Eğer okul_id null/undefined ise boş array ata
    const isYetkili = yetkiliOkullar.includes(Number(okul?.id));
    if (subeQuery && subeQuery.profil && (!subeQuery.profil.is_yetkili || !isYetkili))  {
      setGlobalNotification({
        type: 'warning',
        message: 'Yetkisiz Erişim',
        description: 'Yetkili hesabınız yok. Anasayfaya yönlendiriliyorsunuz...',
      })
      navigate('/')
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subeQuery])

  if (error || subeError) {
    console.log(error)
  }
  if (queryLoading || subeLoading) {
    return <Spinner showSpinner={queryLoading} color={'red'}></Spinner>
  }
  if (!data) {
    return null
  }
  const handleLogout = () => {
    clearLoginSession()
    setToken(DEFAULT_API_TOKEN)
    setAuthState(AuthState.LOGGED_OUT)
    navigate('/') // Ana sayfaya yönlendirme
  }
  return (
    <div
      className={classes}
      style={{
        //sonradan renk1 ve renk2 olarak değiştir.
        background: `linear-gradient(to bottom, ${'#131130'} 0%, ${'#131130'} 93%,  ${renk1} 93%)`,
      }}
    >
      <Toolbar
        contentLeft={
          isSmallScreen ? (
            <>
              <Button
                type="default"
                icon={<MenuOutlined />}
                onClick={handleDrawerOpen}
                className="mobile-menu-button"
              />
            </>
          ) : (
            <div className="admin-panel-title">Yetkili Yönetim Paneli</div>
          )
        }
        contentRight={
          <>
            <div className="name">
              <span>Hoşgeldiniz</span>
              <span>{data?.profil?.isim}</span>
            </div>
            <div className="account-information">
              <UserIcon />
            </div>
            <div className="log-out">
              <LogoutOutlined onClick={handleLogout} />
            </div>
            {/*<AdminSearchbar/>*/}
            {/*//todo: kullanıcı bilgileri gelebilir*/}
            {/*<LanguageDropdown />*/}
            {/*<Select style={{ marginTop: 5 }} defaultValue="5.12.1">*/}
            {/*    <Option value="5.12.1">5.12.1</Option>*/}
            {/*</Select>*/}
          </>
        }
      />
    </div>
  )
}

export default HeaderAdmin
